// import Blog Img
import Blog1 from "../../../assets/img/blog/blog-1.png"
import Blog2 from "../../../assets/img/blog/blog-2.png"
import Blog3 from "../../../assets/img/blog/blog-3.png"

// Import Icon
import IconUser from "../../../assets/img/icon/user.png"
import IconDate from "../../../assets/img/icon/cal.png"




export const NewsData = [
 
  {
    img:Blog1,
    heading:`Badminton ladder & new hall times`,
    category:"#Badminton",
    para:`Year-round main activity: court schedule and ladder updates for juniors and adults.`,
    IconUser:IconUser,
    IconDate:IconDate
  },

  {
    img:Blog2,
    heading:`Integration evening — school partnerships`,
    category:"#Integration",
    para:`How Swedish schools communicate with families, and how PCF can help you prepare for meetings.`,
    IconUser:IconUser,
    IconDate:IconDate
  },
  {
    img:Blog3,
    heading:`Seasonal swim block — registration`,
    category:"#Swimming",
    para:`Summer-oriented pool sessions for children; badminton continues indoors all year.`,
    IconUser:IconUser,
    IconDate:IconDate
  },

]
